/**
 * Legacy wishlist price references use `"-"` for "no reference"; the canonical PnA queries
 * (and their cache keys) use `""`. Shared by the query hook and the slice thunks so both sides
 * of the cache stay key-compatible.
 */
export const normalizeWishlistPriceReference = (priceReference: string) =>
  priceReference === "-" ? "" : priceReference;
